<template>
	<div>
		<b-modal ref="report-modal" hide-footer title="Report Post">
			<b-container>
				<b-row>
					<p class="warning-text">Why are you reporting this post?</p>
				</b-row>
				<div class="report-choice-outter">
					<input class="report-choice" type="radio" id="suspicious" value="Suspicious, spam or fake"
						v-model="reason" />
					<label for="suspicious">Suspicious, spam or fake</label>
				</div>
				<div class="report-choice-outter">
					<input class="report-choice" type="radio" id="harassment" value="Harassment or hateful speech"
						v-model="reason" />
					<label for="harassment">Harassment or hateful speech</label>
				</div>
				<div class="report-choice-outter">
					<input class="report-choice" type="radio" id="violence" value="Violence or phisical harm"
						v-model="reason" />
					<label for="violence">Violence or phisical harm</label>
				</div>
				<div class="report-choice-outter">
					<input class="report-choice" type="radio" id="adult" value="Adult content" v-model="reason" />
					<label for="adult">Adult content</label>
				</div>
				<div class="report-choice-outter">
					<input class="report-choice" type="radio" id="intellectual"
						value="Intellectual property infringment or defamation" v-model="reason" />
					<label for="intellectual">Intellectual property infringment or defamation</label>
				</div>

				<b-row class="justify-content-end">
					<b-button @click="handleReport" size="sm" variant="primary" class="ok-btn">Report</b-button>
					<b-button @click="$refs['report-modal'].hide()" size="sm" class="cancel-btn">Cancel</b-button>
				</b-row>
			</b-container>
		</b-modal>

		<b-modal ref="report-success-modal" hide-footer title="Report Post">
			<b-container>
				<b-row class="mb-2">
					<p>Thank you!

						Your report has been sent to the CC Team.
						We will check the reported post and take appropriate measures asap. </p>
				</b-row>
				<b-row class="justify-content-end">
					<b-button @click="onPostReport" size="sm" variant="primary" class="ok-btn">Continue</b-button>
				</b-row>
			</b-container>

		</b-modal>
	</div>
</template>
  
<script>
import { mapActions } from 'vuex';

export default {
	name: 'ReportModals',
	props: {
		post: {
			type: Object,
			default: () => { },
		},
	},
	data() {
		return {
			reason: '',
		};
	},
	methods: {
		...mapActions({
			'reportPost': 'posts/reportPost',
		}),
		async handleReport() {
			if (!this.reason) {
				return this.$notify({
					group: 'userAlerts',
					title: 'Warning',
					text: 'Please select a reason!',
					type: 'warn',
				});
			}
			await this.reportPost({
				postUrl: this.post.url,
				reason: this.reason,
			})
			this.$refs['report-modal'].hide();
			this.$refs['report-success-modal'].show();
		},
		onPostReport() {
			this.$refs['report-success-modal'].hide();
			this.$emit('reportSuccess', {
				postUrl: this.post.url,
				reason: this.reason,
			});
		},
	},
};
</script>
  
<style scoped>
.col {
	position: relative;
	width: 100%;
	padding-right: 15px;
	padding-left: 5px;
	padding-bottom: 12px;
}

.report-choice-outter {
	border-top: 1px solid #ebebeb;
	margin: 10px 5px;
	padding-top: 10px;
	cursor: pointer;
}

.report-choice-outter label {
	margin-bottom: 0;
	margin-left: 15px;
	cursor: pointer;
}

.container {
	margin-top: 0px;
	padding-left: 10px;
	padding-right: 10px;
}

.warning-text {
	padding: 0 20px;
}

.btn-primary {
	color: white !important;
	background-color: #BD9D5F !important;
	border: none !important;
	font-weight: 600 !important;
	margin-right: 10px;
}

.btn-secondary {
	color: #BD9D5F !important;
	background-color: white !important;
	border: 1px solid #BD9D5F !important;
	font-weight: 600 !important;
}
</style>
  